/**
 * @generated SignedSource<<b479d7196c66c4504e1e2601d4bf1e08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BasicMetadata = {
  description?: string | null | undefined;
  title: string;
};
export type AclItem = {
  actions: ReadonlyArray<string>;
  role: string;
};
export type CreateSeriesMutation$variables = {
  acl: ReadonlyArray<AclItem>;
  metadata: BasicMetadata;
};
export type CreateSeriesMutation$data = {
  readonly createSeries: {
    readonly id: string;
  };
};
export type CreateSeriesMutation = {
  response: CreateSeriesMutation$data;
  variables: CreateSeriesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acl"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadata"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "acl",
        "variableName": "acl"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "metadata"
      }
    ],
    "concreteType": "Series",
    "kind": "LinkedField",
    "name": "createSeries",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSeriesMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateSeriesMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7977397051ad549693d5017af6ec855e",
    "id": null,
    "metadata": {},
    "name": "CreateSeriesMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSeriesMutation(\n  $metadata: BasicMetadata!\n  $acl: [AclItem!]!\n) {\n  createSeries(metadata: $metadata, acl: $acl) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e24374f67f37bd8b785464d0710bfc1b";

export default node;
